import React from "react";
import { ToastContainer, Zoom } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ToastProvider = () => (
  <ToastContainer
    position="top-right"
    hideProgressBar
    autoClose={3000}
    newestOnTop={true}
    closeOnClick
    closeButton={false}
    rtl={false}
    pauseOnFocusLoss
    draggable
    pauseOnHover
    transition={typeof window !== "undefined" ? Zoom : undefined}
  />
);

export default ToastProvider;
